import React, { Component } from "react";
import firebase from "../Firebase";
import Swal from "sweetalert2";

class MasterData extends Component {
  constructor() {
    super();
    this.state = {
      selectedCollection: "",
      collections: [
        "employees",
        "administrators",
        "check_queue",
        // Tambahkan collection lain yang ingin dikelola
      ],
      data: [],
      isLoading: false,
      editingId: null,
      editingData: {},
      hiddenColumns: [],
      showColumnSelector: false,
    };
  }

  componentWillUnmount() {
    // Tidak pakai onSnapshot realtime
  }

  handleCollectionChange = (e) => {
    const collection = e.target.value;
    this.setState({
      selectedCollection: collection,
      data: [],
      editingId: null,
      hiddenColumns: [],
    });

    if (collection) {
      this.loadHiddenColumnsForCollection(collection);
      this.loadCollectionData(collection);
    }
  };

  loadHiddenColumnsForCollection = (collection) => {
    try {
      const raw = localStorage.getItem(`md_hidden_${collection}`);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          this.setState({ hiddenColumns: parsed });
        }
      }
    } catch (err) {
      // abaikan error parsing
    }
  };

  saveHiddenColumnsForCollection = () => {
    const { selectedCollection, hiddenColumns } = this.state;
    if (!selectedCollection) return;
    try {
      localStorage.setItem(
        `md_hidden_${selectedCollection}`,
        JSON.stringify(hiddenColumns)
      );
    } catch (err) {
      // abaikan error penyimpanan
    }
  };

  loadCollectionData = async (collection) => {
    const target = collection || this.state.selectedCollection;
    if (!target) return;

    this.setState({ isLoading: true });

    try {
      const querySnapshot = await firebase
        .firestore()
        .collection(target)
        .get();

      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      this.setState({ data, isLoading: false });
    } catch (error) {
      console.error("Error loading collection:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Gagal memuat data collection: " + error.message,
      });
      this.setState({ isLoading: false });
    }
  };

  handleEdit = (id, rowData) => {
    this.setState({
      editingId: id,
      editingData: { ...rowData },
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editingId: null,
      editingData: {},
    });
  };

  handleFieldChange = (field, value) => {
    this.setState({
      editingData: {
        ...this.state.editingData,
        [field]: value,
      },
    });
  };

  handleSaveEdit = async () => {
    const { selectedCollection, editingId, editingData } = this.state;

    if (!editingId) return;

    try {
      // Remove id from update data
      const { id, ...updateData } = editingData;

      await firebase
        .firestore()
        .collection(selectedCollection)
        .doc(editingId)
        .update(updateData);

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Data berhasil diupdate",
        timer: 2000,
        showConfirmButton: false,
      });

      this.setState({
        editingId: null,
        editingData: {},
      });
      this.loadCollectionData(selectedCollection);
    } catch (error) {
      console.error("Error updating document:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Gagal mengupdate data: " + error.message,
      });
    }
  };

  handleToggleColumn = (field) => {
    this.setState(
      (prev) => {
        const isHidden = prev.hiddenColumns.includes(field);
        const nextHidden = isHidden
          ? prev.hiddenColumns.filter((f) => f !== field)
          : [...prev.hiddenColumns, field];
        return { hiddenColumns: nextHidden };
      },
      () => this.saveHiddenColumnsForCollection()
    );
  };

  handleShowAllColumns = () => {
    this.setState({ hiddenColumns: [] }, () =>
      this.saveHiddenColumnsForCollection()
    );
  };

  handleHideAllColumns = () => {
    const headers = this.renderTableHeaders() || [];
    this.setState({ hiddenColumns: headers }, () =>
      this.saveHiddenColumnsForCollection()
    );
  };

  handleDelete = async (id) => {
    const { selectedCollection } = this.state;

    const result = await Swal.fire({
      title: "Konfirmasi Hapus",
      text: "Apakah Anda yakin ingin menghapus data ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Ya, Hapus!",
      cancelButtonText: "Batal",
    });

    if (result.isConfirmed) {
      try {
        await firebase
          .firestore()
          .collection(selectedCollection)
          .doc(id)
          .delete();

        Swal.fire({
          icon: "success",
          title: "Terhapus!",
          text: "Data berhasil dihapus.",
          timer: 2000,
          showConfirmButton: false,
        });
        this.loadCollectionData(selectedCollection);
      } catch (error) {
        console.error("Error deleting document:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Gagal menghapus data: " + error.message,
        });
      }
    }
  };

  renderTableHeaders = () => {
    const { data } = this.state;
    if (data.length === 0) return null;

    // Get all unique keys from all documents
    const allKeys = new Set();
    data.forEach((item) => {
      Object.keys(item).forEach((key) => allKeys.add(key));
    });

    return Array.from(allKeys);
  };

  renderCellValue = (value) => {
    if (value === null || value === undefined) {
      return <span className="text-muted">-</span>;
    }

    if (typeof value === "boolean") {
      return value ? "true" : "false";
    }

    if (typeof value === "object") {
      if (value.seconds) {
        // Firestore Timestamp
        const date = new Date(value.seconds * 1000);
        return date.toLocaleString("id-ID");
      }
      return JSON.stringify(value);
    }

    const strValue = String(value);
    if (strValue.length > 100) {
      return strValue.substring(0, 100) + "...";
    }

    return strValue;
  };

  renderEditableCell = (field, value) => {
    const { editingData } = this.state;

    if (field === "id") {
      return (
        <input type="text" className="form-control" value={value} disabled />
      );
    }

    // Handle different data types
    if (typeof value === "boolean") {
      return (
        <select
          className="form-control"
          value={editingData[field] !== undefined ? editingData[field] : value}
          onChange={(e) =>
            this.handleFieldChange(field, e.target.value === "true")
          }
        >
          <option value="true">true</option>
          <option value="false">false</option>
        </select>
      );
    }

    if (typeof value === "object" && value !== null) {
      return (
        <textarea
          className="form-control"
          value={
            editingData[field] !== undefined
              ? JSON.stringify(editingData[field])
              : JSON.stringify(value)
          }
          onChange={(e) => {
            try {
              const parsed = JSON.parse(e.target.value);
              this.handleFieldChange(field, parsed);
            } catch (error) {
              // Invalid JSON, store as string temporarily
              this.handleFieldChange(field, e.target.value);
            }
          }}
          rows="2"
        />
      );
    }

    return (
      <input
        type="text"
        className="form-control"
        value={
          editingData[field] !== undefined ? editingData[field] : value || ""
        }
        onChange={(e) => this.handleFieldChange(field, e.target.value)}
      />
    );
  };

  render() {
    const {
      selectedCollection,
      collections,
      data,
      isLoading,
      editingId,
      hiddenColumns,
      showColumnSelector,
    } = this.state;
    const headers = this.renderTableHeaders();
    const visibleHeaders = (headers || []).filter(
      (h) => !hiddenColumns.includes(h)
    );

    return (
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row">
            <div className="content-header-left col-12 mb-2">
              <h3 className="content-header-title mb-0">Master Data</h3>
              <div className="row breadcrumbs-top">
                <div className="breadcrumb-wrapper col-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/administrator">Home</a>
                    </li>
                    <li className="breadcrumb-item active">Master Data</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="content-body">
            <section id="basic-form-layouts">
              <div className="row match-height">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title" id="basic-layout-form">
                        Pilih Collection
                      </h4>
                    </div>
                    <div className="card-content">
                      <div className="card-body">
                        <div className="form-group">
                          <label htmlFor="collectionSelect">
                            Collection Firebase
                          </label>
                          <select
                            id="collectionSelect"
                            className="form-control"
                            value={selectedCollection}
                            onChange={this.handleCollectionChange}
                          >
                            <option value="">-- Pilih Collection --</option>
                            {collections.map((collection) => (
                              <option key={collection} value={collection}>
                                {collection}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {selectedCollection && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                        <h4 className="card-title mb-0">
                          Data Collection: {selectedCollection}
                          <span className="badge badge-primary ml-2">
                            {data.length} records
                          </span>
                        </h4>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          disabled={isLoading || !selectedCollection}
                          onClick={() =>
                            this.loadCollectionData(selectedCollection)
                          }
                        >
                          <i className="bx bx-refresh"></i>{" "}
                          {isLoading ? "Memuat..." : "Refresh"}
                        </button>
                      </div>
                      <div className="card-content">
                        <div className="card-body">
                          {isLoading ? (
                            <div className="text-center py-5">
                              <div
                                className="spinner-border text-primary"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                              <p className="mt-2">Memuat data...</p>
                            </div>
                          ) : data.length === 0 ? (
                            <div className="alert alert-info" role="alert">
                              <i className="bx bx-info-circle"></i> Tidak ada
                              data di collection ini.
                            </div>
                          ) : (
                            <div className="table-responsive">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <div>
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() =>
                                      this.setState({
                                        showColumnSelector: !showColumnSelector,
                                      })
                                    }
                                  >
                                    <i className="bx bx-columns"></i> Atur Kolom
                                  </button>
                                  {showColumnSelector && (
                                    <div
                                      className="border rounded p-2 mt-2"
                                      style={{
                                        maxWidth: "100%",
                                        background: "#fff",
                                      }}
                                    >
                                      <div
                                        className="d-flex flex-wrap"
                                        style={{ gap: "12px" }}
                                      >
                                        {(headers || []).map((header) => (
                                          <label key={header} className="mb-0">
                                            <input
                                              type="checkbox"
                                              className="mr-1"
                                              checked={
                                                !hiddenColumns.includes(header)
                                              }
                                              onChange={() =>
                                                this.handleToggleColumn(header)
                                              }
                                            />
                                            {header}
                                          </label>
                                        ))}
                                      </div>
                                      <div className="mt-2">
                                        <button
                                          className="btn btn-sm btn-outline-primary mr-1"
                                          onClick={this.handleShowAllColumns}
                                        >
                                          Tampilkan Semua
                                        </button>
                                        <button
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={this.handleHideAllColumns}
                                        >
                                          Sembunyikan Semua
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <table className="table table-striped table-bordered table-sticky-actions">
                                <thead>
                                  <tr>
                                    {visibleHeaders.map((header) => (
                                      <th
                                        key={header}
                                        style={{ minWidth: "150px" }}
                                      >
                                        {header}
                                      </th>
                                    ))}
                                    <th
                                      className="sticky-col"
                                      style={{ minWidth: "150px" }}
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {data.map((row) => (
                                    <tr key={row.id}>
                                      {visibleHeaders.map((header) => (
                                        <td key={header}>
                                          {editingId === row.id
                                            ? this.renderEditableCell(
                                                header,
                                                row[header]
                                              )
                                            : this.renderCellValue(row[header])}
                                        </td>
                                      ))}
                                      <td className="sticky-col">
                                        {editingId === row.id ? (
                                          <div
                                            className="btn-group"
                                            role="group"
                                          >
                                            <button
                                              className="btn btn-sm btn-success"
                                              onClick={this.handleSaveEdit}
                                            >
                                              <i className="bx bx-check"></i>{" "}
                                              Simpan
                                            </button>
                                            <button
                                              className="btn btn-sm btn-secondary"
                                              onClick={this.handleCancelEdit}
                                            >
                                              <i className="bx bx-x"></i> Batal
                                            </button>
                                          </div>
                                        ) : (
                                          <div
                                            className="btn-group"
                                            role="group"
                                          >
                                            <button
                                              className="btn btn-sm btn-primary"
                                              onClick={() =>
                                                this.handleEdit(row.id, row)
                                              }
                                            >
                                              <i className="bx bx-edit"></i>{" "}
                                              Edit
                                            </button>
                                            <button
                                              className="btn btn-sm btn-danger"
                                              onClick={() =>
                                                this.handleDelete(row.id)
                                              }
                                            >
                                              <i className="bx bx-trash"></i>{" "}
                                              Hapus
                                            </button>
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default MasterData;
